import React from 'react';
import { Layout } from '../components/Layout';
import { Button } from '../components/Button';
import { MapPin, Clock, Phone, Mail, ShoppingBag, Sofa, Lightbulb, Frame } from 'lucide-react';
import { Link } from 'react-router-dom';
export function StoreInfo() {
  return <Layout data-id="element-460">
      {/* Hero Section */}
      <section className="relative py-32 px-4 bg-gradient-to-br from-taupe-200/50 to-cream-100 border-b border-taupe-200" data-id="element-461">
        <div className="max-w-4xl mx-auto text-center" data-id="element-462">
          <span className="text-sage-600 uppercase tracking-[0.2em] text-xs font-semibold mb-6 block" data-id="element-463">
            Visit Us
          </span>
          <h1 className="text-4xl md:text-6xl font-serif text-charcoal-900 mb-6 leading-tight" data-id="element-464">
            Experience Design
            <br data-id="element-465" />
            <span className="italic" data-id="element-466">in Person</span>
          </h1>
          <p className="text-xl text-charcoal-900/70 leading-relaxed max-w-2xl mx-auto" data-id="element-467">
            Our Howell showroom is open and ready to inspire your next project.
          </p>
        </div>
      </section>

      {/* Visit Our Store */}
      <section className="py-24 px-4 bg-white" data-id="element-468">
        <div className="max-w-4xl mx-auto text-center" data-id="element-469">
          <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-8" data-id="element-470">
            Your Destination for Inspired Living
          </h2>
          <p className="text-lg text-charcoal-900/70 leading-relaxed mb-6" data-id="element-471">
            Step into Down Home Interiors and discover a thoughtfully curated
            collection of furniture, home décor, and accessories. Our showroom
            is designed to inspire, with room vignettes that showcase how pieces
            work together to create cohesive, livable spaces.
          </p>
          <p className="text-lg text-charcoal-900/70 leading-relaxed" data-id="element-472">
            Whether you're furnishing an entire home or looking for that perfect
            finishing touch, our team is here to help you find exactly what you
            need. We also offer design consultations right in the store—bring
            your room measurements, photos, or fabric samples and let us help
            you create a plan.
          </p>
        </div>
      </section>

      {/* Location & Hours */}
      <section className="py-24 px-4 bg-cream-100" data-id="element-473">
        <div className="max-w-6xl mx-auto" data-id="element-474">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-475">
            {/* Contact Information */}
            <div className="space-y-8" data-id="element-476">
              <div className="bg-white p-8 border border-taupe-200 shadow-card" data-id="element-477">
                <div className="flex items-start gap-4 mb-6" data-id="element-478">
                  <MapPin className="text-sage-500 flex-shrink-0 mt-1" size={24} data-id="element-479" />
                  <div data-id="element-480">
                    <h3 className="text-xl font-serif text-charcoal-900 mb-3" data-id="element-481">
                      Location
                    </h3>
                    <address className="not-italic text-lg text-charcoal-900/70 leading-relaxed" data-id="element-482">
                      2729 E. Grand River Ave.
                      <br data-id="element-483" />
                      Howell, MI 48843
                    </address>
                  </div>
                </div>
                <a href="https://www.google.com/maps/search/?api=1&query=2729+E.+Grand+River+Ave.+Howell+MI+48843" target="_blank" rel="noopener noreferrer" className="inline-block" data-id="element-484">
                  <Button variant="outline" size="sm" data-id="element-485">
                    Get Directions
                  </Button>
                </a>
              </div>

              <div className="bg-white p-8 border border-taupe-200 shadow-card" data-id="element-486">
                <div className="flex items-start gap-4 mb-6" data-id="element-487">
                  <Clock className="text-sage-500 flex-shrink-0 mt-1" size={24} data-id="element-488" />
                  <div className="flex-1" data-id="element-489">
                    <h3 className="text-xl font-serif text-charcoal-900 mb-4" data-id="element-490">
                      Store Hours
                    </h3>
                    <div className="space-y-3" data-id="element-491">
                      <div className="flex justify-between items-center pb-3 border-b border-taupe-100" data-id="element-492">
                        <span className="text-charcoal-900/70" data-id="element-493">
                          Monday – Friday
                        </span>
                        <span className="font-medium text-charcoal-900" data-id="element-494">
                          10:00 AM – 6:00 PM
                        </span>
                      </div>
                      <div className="flex justify-between items-center pb-3 border-b border-taupe-100" data-id="element-495">
                        <span className="text-charcoal-900/70" data-id="element-496">Saturday</span>
                        <span className="font-medium text-charcoal-900" data-id="element-497">
                          10:00 AM – 4:00 PM
                        </span>
                      </div>
                      <div className="flex justify-between items-center" data-id="element-498">
                        <span className="text-charcoal-900/70" data-id="element-499">Sunday</span>
                        <span className="font-medium text-charcoal-900" data-id="element-500">
                          Closed
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <p className="text-sm text-charcoal-900/60 italic" data-id="element-501">
                  Hours may vary during holidays. Call ahead to confirm.
                </p>
              </div>

              <div className="bg-white p-8 border border-taupe-200 shadow-card" data-id="element-502">
                <div className="flex items-start gap-4" data-id="element-503">
                  <Phone className="text-sage-500 flex-shrink-0 mt-1" size={24} data-id="element-504" />
                  <div data-id="element-505">
                    <h3 className="text-xl font-serif text-charcoal-900 mb-3" data-id="element-506">
                      Contact
                    </h3>
                    <div className="space-y-2 text-charcoal-900/70" data-id="element-507">
                      <p className="flex items-center gap-2" data-id="element-508">
                        <Phone size={16} data-id="element-509" />
                        <span data-id="element-510">(555) 123-4567</span>
                      </p>
                      <p className="flex items-center gap-2" data-id="element-511">
                        <Mail size={16} data-id="element-512" />
                        <span data-id="element-513">hello@downhomeinteriors.com</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Map Placeholder */}
            <div className="h-full min-h-[600px] bg-taupe-300 flex items-center justify-center text-charcoal-900/30 text-xl font-serif border border-taupe-200 shadow-card" data-id="element-514">
              <div className="text-center p-8" data-id="element-515">
                <MapPin className="mx-auto mb-4 text-charcoal-900/20" size={48} data-id="element-516" />
                <p data-id="element-517">[Google Maps Embed Placeholder]</p>
                <p className="text-sm mt-4 text-charcoal-900/20" data-id="element-518">
                  {/* Replace with: <iframe src="https://www.google.com/maps/embed?pb=..." ... */}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What You'll Find In-Store */}
      <section className="py-24 px-4 bg-white" data-id="element-519">
        <div className="max-w-6xl mx-auto" data-id="element-520">
          <div className="text-center mb-16" data-id="element-521">
            <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-4" data-id="element-522">
              What You'll Find In-Store
            </h2>
            <p className="text-lg text-charcoal-900/60 max-w-2xl mx-auto" data-id="element-523">
              A carefully curated selection for every room in your home
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-524">
            {[{
            icon: <Sofa className="text-sage-500" size={32} data-id="element-525" />,
            title: 'Furniture',
            description: 'Sofas, chairs, tables, and bedroom sets in classic and contemporary styles'
          }, {
            icon: <Lightbulb className="text-sage-500" size={32} data-id="element-526" />,
            title: 'Lighting',
            description: 'Table lamps, floor lamps, chandeliers, and decorative fixtures'
          }, {
            icon: <Frame className="text-sage-500" size={32} data-id="element-527" />,
            title: 'Décor & Art',
            description: 'Wall art, mirrors, vases, and accessories to complete your space'
          }, {
            icon: <ShoppingBag className="text-sage-500" size={32} data-id="element-528" />,
            title: 'Apparel & Gifts',
            description: 'Boutique clothing, jewelry, and unique gift items'
          }].map((category, index) => <div key={index} className="text-center" data-id="element-529">
                <div className="w-20 h-20 bg-sage-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-530">
                  {category.icon}
                </div>
                <h3 className="text-xl font-serif text-charcoal-900 mb-3" data-id="element-531">
                  {category.title}
                </h3>
                <p className="text-charcoal-900/70 leading-relaxed" data-id="element-532">
                  {category.description}
                </p>
              </div>)}
          </div>

          <div className="mt-16 bg-cream-50 p-8 md:p-12 border border-taupe-200 text-center" data-id="element-533">
            <h3 className="text-2xl font-serif text-charcoal-900 mb-4" data-id="element-534">
              Can't Find What You're Looking For?
            </h3>
            <p className="text-lg text-charcoal-900/70 mb-6 max-w-2xl mx-auto" data-id="element-535">
              Our showroom represents just a fraction of what we can source for
              you. With access to hundreds of manufacturers and craftspeople, we
              can help you find or create exactly what you need.
            </p>
            <Link to="/contact" data-id="element-536">
              <Button data-id="element-537">Schedule a Consultation</Button>
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 px-4 bg-gradient-to-br from-taupe-200/50 to-cream-100" data-id="element-538">
        <div className="max-w-4xl mx-auto text-center" data-id="element-539">
          <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-6" data-id="element-540">
            We'd Love to See You
          </h2>
          <p className="text-xl text-charcoal-900/70 mb-10 leading-relaxed max-w-2xl mx-auto" data-id="element-541">
            Stop by during our regular hours or contact us to schedule a private
            appointment.
          </p>
          <Link to="/contact" data-id="element-542">
            <Button size="lg" data-id="element-543">Contact Us</Button>
          </Link>
        </div>
      </section>
    </Layout>;
}